import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import About from "../components/About";
import Services from "../components/Services";
import WhyChoose from "../components/WhyChoose";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import ProductFeatures from "../components/ProductFeatures";
import OurProducts from "../components/OurProducts";
import FeaturedProducts from "../components/FeaturedProducts";
import Calltoaction from "../components/Calltoaction";

const Home = () => {
  return (
    <>
      <Navbar />

      <div id="home"><Hero /></div>
      <div id="about"><About /></div>
      <div id="product-features"><ProductFeatures /></div>
      <div id="services"><Services /></div>
      <div id="products"><OurProducts /></div>
      <div id="why-choose"><WhyChoose /></div>
      <div id="featured"><FeaturedProducts /></div>
      <div id="cta"><Calltoaction /></div>
      <div id="contact"><Contact /></div>

      <Footer />
    </>
  );
};

export default Home;